
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"78","height":"78","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M53.03 37.83c-9.37 0-16.995 7.625-16.995 16.995 0 9.37 7.625 16.995 16.995 16.995 9.37 0 16.995-7.624 16.995-16.995 0-9.37-7.625-16.995-16.995-16.995zm0 30.9c-7.67 0-13.905-6.242-13.905-13.905 0-7.663 6.234-13.905 13.905-13.905 7.671 0 13.905 6.242 13.905 13.905 0 7.663-6.234 13.905-13.905 13.905z","fill":"#fff","stroke":"#fff","stroke-width":"2.25"}}),_c('path',{attrs:{"d":"M31.4 68.73H15.95a4.639 4.639 0 01-4.635-4.635V31.65H65.39a1.55 1.55 0 001.545-1.545v-9.27c0-4.256-3.468-7.725-7.725-7.725h-7.725V8.475A1.55 1.55 0 0049.94 6.93a1.55 1.55 0 00-1.545 1.545v4.635h-21.63V8.475A1.55 1.55 0 0025.22 6.93a1.55 1.55 0 00-1.545 1.545v4.635H15.95c-4.257 0-7.725 3.469-7.725 7.725v43.26c0 4.257 3.468 7.725 7.725 7.725H31.4a1.55 1.55 0 001.545-1.545A1.55 1.55 0 0031.4 68.73zM11.315 20.835A4.639 4.639 0 0115.95 16.2h7.725v4.635c0 .85.695 1.545 1.545 1.545a1.55 1.55 0 001.545-1.545V16.2h21.63v4.635c0 .85.695 1.545 1.545 1.545a1.55 1.55 0 001.545-1.545V16.2h7.725a4.639 4.639 0 014.635 4.635v7.725h-52.53v-7.725z","fill":"#fff","stroke":"#fff","stroke-width":"2.25"}}),_c('path',{attrs:{"d":"M54.575 54.184v-4.766a1.55 1.55 0 00-1.545-1.545 1.55 1.55 0 00-1.545 1.545v5.407c0 .41.162.803.456 1.09l3.862 3.862a1.54 1.54 0 001.09.456 1.548 1.548 0 001.09-2.642l-3.408-3.407z","fill":"#fff","stroke":"#fff","stroke-width":"2.25"}})])
          )
        }
      }
    